var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "currentColor",
    viewBox: "0 0 24 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 23.913 9.995-10.906-9.983-10.9 1-1.097L18 13 7.006 25.01 6 23.913Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronRightFilled.67020a8ea30fbbf9fccf3b3de72e912b.svg";